// CategoriesSettings.module.css
import React from 'react';
import { Book, Video, FileVideo, BookOpen, Headphones, ArrowLeft } from 'lucide-react';
import styles from './CategoriesSettings.module.css';
import { useNavigate } from 'react-router-dom';

function CategoriesSettings() {
const navigate=useNavigate()
const handleNavigation = () => {
  navigate("/admin/dashboard", {
    state: { data: "superadmin" },
  });
};
  const categories = [
    {
      title: 'Ebooks Categories',
      icon: <Book size={24} />,
      link:'Ebook'
    },
    {
      title: 'Videos Categories',
      icon: <Video size={24} />,
      link:'Video'

    },
    {
      title: 'Shorts Categories',
      icon: <FileVideo size={24} />,
      link:'Shorts'

    },
    {
      title: 'Blogs Categories',
      icon: <BookOpen size={24} />,
      link:'Blogs'

    },
    {
      title: 'Audio Categories',
      icon: <Headphones size={24} />,
      link:'Audio'

    }
  ];

  return (
    <div className={styles.container}>
     <div className={styles.headerContent}>
          <div className={styles.headerTop}>
            <h1 className={styles.title}>All Categories</h1>
            <button
              className={styles.backButton}
              onClick={handleNavigation}
            >
              <ArrowLeft size={20} />
              <span>Back</span>
            </button>
          </div>
        </div>
      <div className={styles.grid}>
        {categories.map((category, index) => (
          <div key={index} className={styles.card} onClick={()=>navigate(`/admin/categories/${category.link}`)}>
            <div className={styles.iconWrapper}>
              {category.icon}
            </div>
            <h2 className={styles.categoryTitle}>{category.title}</h2>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CategoriesSettings;